<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">Player Management</a>
    <div class="collapse navbar-collapse">
      <button class="btn btn-sm btn-outline-primary ms-auto" (click)="export()">Export</button>
    </div>
  </div>
</nav>
<div class="row mt-2">
  <div class="col-12">
    <app-tablev2 #table></app-tablev2>
  </div>
</div>